import { MARQUEE_ITEMS } from "./config";

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    aria-hidden="true"
    className="overflow-hidden border-y border-white/[0.06] py-5"
  >
    <div className="marquee-track flex w-max items-center gap-10 pr-10">
      {[...MARQUEE_ITEMS, ...MARQUEE_ITEMS].map((item, i) => (
        <span key={i} className="flex items-center gap-10 whitespace-nowrap">
          <span className="text-xs font-bold uppercase tracking-[0.28em] text-paper/30 sm:text-sm">{item}</span>
          <span className="h-1.5 w-1.5 rotate-45 bg-lilac/45" />
        </span>
      ))}
    </div>
  </div>
);
